import React, { ComponentType, ComponentProps } from "react";
import { NavLink, useLocation, useParams } from "react-router-dom";

import "./AppFooter.scss";
import { ROUTES } from "../../utils/constants";
import { AppNavigationRoute } from "../layouts/AppLayout/types";
import useAuth from "../../hooks/useAuth";
import { checkOs, isGamesPagePath } from "../../utils/helpers";
import { OperatingSystems } from "../../utils/vendor";
import { usePwaContext } from "../../context/pwa-context";

interface NavItemProps {
  Icon: ComponentType<ComponentProps<"svg">>;
  name: string;
  href: string;
  userIsLoggedIn: boolean;
  isNavActive?: boolean;
}

function NavItem({
  Icon,
  name,
  href,
  userIsLoggedIn,
  isNavActive,
}: NavItemProps) {
  const destination =
    !userIsLoggedIn && href !== ROUTES.GAMES.ROOT
      ? ROUTES.ROOT.LOG_IN
      : href;

  return (
    <NavLink to={destination} className="nav-item">
      {({ isActive }) => (
        <>
          <Icon data-active={isNavActive ?? isActive} />
          <span data-active={isNavActive ?? isActive}>{name}</span>
        </>
      )}
    </NavLink>
  );
}

const GAMES_PAGE_ROUTE = `${ROUTES.GAMES.ROOT}`;
const HOMEPAGE = ROUTES.ROOT.HOME;
const LOGGED_OUT_NAV_ROUTES = [
  ROUTES.ROOT.DASHBOARD,
  ROUTES.GAMES.ROOT,
  ROUTES.WALLET.ROOT,
];

function AppFooter({ routes }: { routes: AppNavigationRoute[] }) {
  const os = checkOs();
  const { slug } = useParams();
  const { pathname } = useLocation();
  const { isLoggedIn: userIsLoggedIn } = useAuth();
  const isGamesPageRoute = isGamesPagePath(pathname, slug);
  const { userIsInPwa } = usePwaContext();

  return (
    <footer
      className={`nav-footer MobileOnly ${
        isGamesPageRoute ? "GamesPageFooter" : ""
      } ${os === OperatingSystems.Ios ? "Ios" : ""} ${
        userIsInPwa ? "Pwa" : ""
      }`}
    >
      {routes
        .filter(
          (route) =>
            userIsLoggedIn || LOGGED_OUT_NAV_ROUTES.includes(route.href)
        )
        .map(({ icon, name, href }) => (
          <NavItem
            key={name}
            Icon={icon}
            name={name}
            href={href}
            userIsLoggedIn={userIsLoggedIn}
            isNavActive={
              pathname === HOMEPAGE && href === GAMES_PAGE_ROUTE
                ? true
                : undefined
            }
          />
        ))}
    </footer>
  );
}

export default AppFooter;
